import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { formatDateTimezon } from "../../common-data/Converts";
import {
  CallIcon,
  PersonIcon,
  EmailIcon,
  CalenderIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "../../../images/icons/icons";
import CommonTable from "../../common-components/common-tables/CommonTable";
import { fetchWTF360InquiryData } from "../../../redux/prospect-reducers/prospectSlice";
import CmnFilters from "../../lead-management/common/CmnFilters";

const WTF360ODMListings = (props) => {
  const dispatch = useDispatch();
  const { wtf360InquiryLoading, wtf360InquiryError, wtf360Inquiry } =
    useSelector((state) => state.prospects);

  const { userInfoData } = props || {};

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniAllFilter = {
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);

  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit,
    from_date: allFilters.leadAddDateFrom || "",
    to_date: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const iniDatas = {
    pagination: [],
    allLeads: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setIsPage(0);
  };

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const getWTF360Inquiry = (filtersToUse) => {
    dispatch(
      fetchWTF360InquiryData({
        filters: filtersToUse || filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getWTF360Inquiry();
  }, [filters]);

  useEffect(() => {
    if (
      !wtf360InquiryLoading &&
      !wtf360InquiryError &&
      wtf360Inquiry?.status &&
      wtf360Inquiry?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allLeads: wtf360Inquiry.data,
        pagination:
          wtf360Inquiry?.pagination?.length > 0 ? wtf360Inquiry.pagination : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [wtf360InquiryLoading, wtf360InquiryError, wtf360Inquiry]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
      from_date: allFilters.leadAddDateFrom || "",
      to_date: allFilters.leadAddDateTo || "",
    }));
  }, [isPage, pageLimit, allFilters.leadAddDateFrom, allFilters.leadAddDateTo]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    // {
    //   dataField: "added_to_lead",
    //   text: "Action",
    //   formatter: (_, row) => (
    //     <div className="pp-employee-payroll-actions">
    //       {row?.added_to_lead ? (
    //         <button
    //           key="view"
    //           type="button"
    //           className="pp-employee-payroll-action-button pp-outlined-border"
    //           onClick={() =>
    //             setModValues((prevs) => ({
    //               ...prevs,
    //               isModOpen: true,
    //               rowData: row,
    //               modName: "view-lead-journey",
    //             }))
    //           }
    //         >
    //           <EyeIcon />
    //           View Lead
    //         </button>
    //       ) : (
    //         <button
    //           key="add-to-lmd"
    //           type="button"
    //           className="pp-employee-payroll-action-button pp-outlined-border"
    //           onClick={() =>
    //             setModValues((prevs) => ({
    //               ...prevs,
    //               isModOpen: true,
    //               rowData: row,
    //               modName: "add-to-lead",
    //             }))
    //           }
    //         >
    //           <ExcludeIcon />
    //           Add To LMS
    //         </button>
    //       )}

    //       <button
    //         key="click-to-call"
    //         type="button"
    //         className="pp-employee-payroll-action-button pp-outlined-border"
    //         onClick={() => {
    //           setModValues({
    //             isModOpen: true,
    //             modName: "click-to-call",
    //             rowData: row,
    //           });
    //         }}
    //       >
    //         <CallIcon color="#000" />
    //         Click to Call
    //       </button>
    //     </div>
    //   ),
    // },
    {
      dataField: "uid",
      text: "Member Info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              // onClick={() =>
              //   setModValues((prevs) => ({
              //     ...prevs,
              //     isModOpen: true,
              //     modName: "view_details",
              //     rowData: row,
              //     from: "wtf-360",
              //   }))
              // }
            >
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.full_name || "NA"}</span>
            </div>

            {row?.phone_number && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.phone_number || "NA"}</span>
              </div>
            )}

            {row?.email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">{row.email || "NA"}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <CalenderIcon />
            </span>
            <span className="tb-data">
              {formatDateTimezon(row?.date_added)}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "payment_status",
      text: "payment Status",
      formatter: (_, row) => {
        const status = row?.payment_status;

        return (
          <span className={`tb-data tb-icon`}>
            {status ? <CheckCircleIcon /> : <XCircleIcon />}
          </span>
        );
      },
    },
    // {
    //   dataField: "status",
    //   text: "Status",
    //   formatter: (_, row) => {
    //     const status = row?.status?.toLowerCase();
    //     return (
    //       <span
    //         className={`tb-data ${status ? "tb-badge" : ""} ${
    //           status === "completed" || status === "converted"
    //             ? "tb-badge-success"
    //             : status === "pending"
    //             ? "tb-badge-success-2"
    //             : status === "cancelled" || status === "expired"
    //             ? "not-assigned"
    //             : status
    //             ? "tb-badge-success-1"
    //             : ""
    //         }`}
    //       >
    //         {row?.status || "NA"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "activity_level",
      text: "activity level",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.activity_level?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "city",
      text: "city",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.city || "NA"}</span>;
      },
    },
    {
      dataField: "preferred_language",
      text: "preferred language",
      formatter: (_, row) => {
        return (
          <span className="tb-data">{row?.preferred_language || "NA"}</span>
        );
      },
    },
    {
      dataField: "preferred_call_time",
      text: "preferred call time",
      formatter: (_, row) => {
        return (
          <span className="tb-data">{row?.preferred_call_time || "NA"}</span>
        );
      },
    },
    {
      dataField: "primary_goal",
      text: "primary goal",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.primary_goal?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "health_conditions",
      text: "health conditions",
      formatter: (_, row) => {
        const healthConditions = row?.health_conditions;
        let displayValue = "NA";

        if (healthConditions) {
          if (typeof healthConditions === "string") {
            displayValue = healthConditions.replace(/_/g, " ");
          } else if (Array.isArray(healthConditions)) {
            displayValue = healthConditions.join(", ").replace(/_/g, " ");
          } else {
            displayValue = String(healthConditions);
          }
        }

        return <span className="tb-data">{displayValue}</span>;
      },
    },
  ];

  return (
    <Row>
      <Col>
        <CmnFilters
          from="odm-wtf-360"
          userInfoData={userInfoData}
          onClickReset={onResetFilters}
          filters={allFilters}
          setFilters={setAllFilters}
          onClickSearch={onClickSearch}
          searchFilterApplied={searchFilterApplied}
          isReload={() => getWTF360Inquiry()}
          isLoading={wtf360InquiryLoading}
        />

        <div className="common-table-container tb-bordered mt15">
          <CommonTable
            tableData={allDatas.allLeads}
            tablePagination={allDatas.pagination}
            tableColumns={tbColumns}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            isLoading={wtf360InquiryLoading}
          />
        </div>

        {/* <div className="lead-logs-card-container only-mobile">
          {wtf360InquiryLoading ? (
            <CalendarLoader daysCount={5} shiftsPerDay={2} />
          ) : (
            <div className="mobile-card-list">
              {allDatas.allLeads?.length > 0 ? (
                allDatas.allLeads.map((row, index) => (
                  <div key={index} className="mobile-card">
                    <div className="mobile-card-header">
                      <span className="mobile-card-title">
                        {row?.user_name || "NA"}
                      </span>
                      <span
                        className={`mobile-card-badge ${
                          row?.status?.toLowerCase() === "completed" ||
                          row?.status?.toLowerCase() === "converted"
                            ? "success"
                            : row?.status?.toLowerCase() === "pending"
                            ? "warning"
                            : "danger"
                        }`}
                      >
                        {row?.status || "NA"}
                      </span>
                    </div>
                    <div className="mobile-card-body">
                      <p>
                        <strong>Mobile:</strong> {row?.user_mobile || "NA"}
                      </p>
                      <p>
                        <strong>Gym:</strong> {row?.gym_name || "NA"}
                      </p>
                      <p>
                        <strong>Type:</strong> {row?.inquiry_type || "NA"}
                      </p>
                      <p>
                        <strong>Date:</strong>{" "}
                        {row?.inquiry_date
                          ? formatDateTimezon(row.inquiry_date)
                          : "NA"}
                      </p>
                    </div>
                    <div className="mobile-card-actions">
                      {row?.added_to_lead ? (
                        <button
                          onClick={() =>
                            setModValues({
                              isModOpen: true,
                              modName: "view-lead-journey",
                              rowData: row,
                            })
                          }
                        >
                          View Lead
                        </button>
                      ) : (
                        <button
                          onClick={() =>
                            setModValues({
                              isModOpen: true,
                              modName: "add-to-lead",
                              rowData: row,
                            })
                          }
                        >
                          Add To LMS
                        </button>
                      )}
                      <button
                        onClick={() =>
                          setModValues({
                            isModOpen: true,
                            modName: "click-to-call",
                            rowData: row,
                          })
                        }
                      >
                        Call
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-data-found">No data available</div>
              )}
            </div>
          )}
        </div> */}
      </Col>
    </Row>
  );
};

export default WTF360ODMListings;
